import {Route, Routes} from 'react-router';
import '../stylesheets/App.css';
import Main from './Main';
import Writings from './Writings';
import BlogPost from './BlogPost';

function App() {
  return (
    <Routes>
      <Route path='/' exact element={<Main />}/>
      <Route path='/writings' element={<Writings />}/>
      <Route path='/blog/:slug' element={<BlogPost />}/>
      <Route path='*' element={<Main />}/>
    </Routes>
  );
}

export default App;
